export default "__VITE_ASSET__uZ2VxlMX__"